import { useState } from 'react';

import { SiteFooterView } from '@/components/riviera/site-footer-view';
import { cities } from '@/lib/events-data';
import { readFooterLinks } from '@/lib/footer-links';
import { FOOTER_LINKS_SEED_KEY, LIST_BUCKET } from '@todo/core/list-queries';
import { prefetchElementId, serializePrefetch } from '@todo/core/static-prefetch';

const allCityIds = cities.map((c) => c.id);

// Web: /boat-rental/[city], /wine-tours/[city], /[city]/events and
// /[city]/tours are only exported for cities with enough listings, so the
// footer must link to exactly that set — the one list-prefetch.ts computed
// for the page generators — or it 404s. The export render reads it from the
// build cache; this footer bakes it into the page as JSON so the browser's
// hydration render reads back the same list (same mechanism as listSeedScript,
// but rendered in the body rather than <Head>). Being on every page, it's also
// the fallback useCityListingPages reads after a client-side navigation.
//
// Bracketed by data-lastmod-skip sentinels, like the detail pages' "more like
// this" blocks: the footer is identical site-wide boilerplate, so a change to
// it (a city gaining its boat-rental page) must not restamp the sitemap
// lastmod of every URL at once — see packages/web-build/src/generate-sitemap.js.
export function SiteFooter() {
  const [links] = useState(readFooterLinks);

  return (
    <>
      <div data-lastmod-skip="start" hidden />
      <SiteFooterView
        // No seed only under `expo start`, where every route resolves.
        boatRentalCityIds={links?.boatRental ?? allCityIds}
        wineTourCityIds={links?.wineTours ?? allCityIds}
        eventCityIds={links?.cityEvents ?? allCityIds}
        tourCityIds={links?.cityTours ?? allCityIds}>
        {links ? (
          <script
            id={prefetchElementId(LIST_BUCKET, FOOTER_LINKS_SEED_KEY)}
            type="application/json"
            // Raw, not a text child: the JSON must reach the DOM unescaped for
            // readBakedState's JSON.parse. serializePrefetch escapes `<`.
            dangerouslySetInnerHTML={{ __html: serializePrefetch(links) }}
          />
        ) : null}
      </SiteFooterView>
      <div data-lastmod-skip="end" hidden />
    </>
  );
}
